/** Affichage des étiquettes d'une tâche, choisi par chaque personne. */
export type TaskTagDisplay = 'chips' | 'border';

export function parseTaskTagDisplay(value: unknown): TaskTagDisplay {
  return value === 'border' ? 'border' : 'chips';
}

/** Texte de la bulle de la bande : les noms des étiquettes, dans l'ordre. */
export function stripeLabel(tags: { name: string }[]): string {
  return tags.map((t) => t.name).join(' · ');
}
